import React, { createContext, useContext, useEffect, useState } from 'react';
import DEFAULT_BRAND from '../config/branding';
import { getBranding } from '../services/settings';
import { setBranding as setStoreBranding, getBranding as getStoreBranding } from '../config/brandingStore';

const BrandingContext = createContext(DEFAULT_BRAND);

export const BrandingProvider = ({ children }) => {
  const [brand, setBrand] = useState(DEFAULT_BRAND);

  useEffect(() => {
    // Load runtime branding from backend
    const load = async () => {
      try {
        const res = await getBranding();
        const data = res.data || {};
        const merged = {
          ...DEFAULT_BRAND,
          ...data,
          pdfHeader: { ...(DEFAULT_BRAND.pdfHeader || {}), ...(data.pdfHeader || {}) },
        };
        setBrand(merged);
        setStoreBranding(merged);
      } catch (e) {
        // fallback to default
        setBrand(DEFAULT_BRAND);
        setStoreBranding(DEFAULT_BRAND);
      }
    };
    load();
  }, []);

  return (
    <BrandingContext.Provider value={brand}>{children}</BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);

export default BrandingContext;
